import { Alert } from "@memento/ui/Alert";
import { useMaxClips } from "src/hooks/useMaxClips";

type MaxClipsWarningProps = {
  clipCount: number;
  getMessage: (args: { max: number; maxFormatted: string }) => string;
  id?: string;
};

export function MaxClipsWarning({
  clipCount,
  getMessage,
  id,
}: MaxClipsWarningProps) {
  const { isMaxed, max, maxFormatted } = useMaxClips({ clipCount });

  if (!isMaxed) {
    return null;
  }

  return (
    <Alert variant="danger" id={id} role="alert">
      {getMessage({ max, maxFormatted })}
    </Alert>
  );
}
